export default {
  ANY: "any",
  STRING: "string",
  NUMBER: "number"
};
